import styled from "styled-components";
import { designTokens, getTypography } from "../../../styles/designTokens";
import HomeBackgroundImage from "@/assets/home/background.svg";
import { MainContainer } from "styles/sharedStyles";

export const BackgroundContainer = styled(MainContainer)`
  position: relative;
  width: 100%;
  min-height: 100vh;

  @media (max-width: 1200px) {
    min-height: 1000px;
  }

  @media (max-width: 768px) {
    min-height: 800px;
  }

  @media (max-width: 480px) {
    min-height: 700px;
  }
`;

export const BackgroundWrapper = styled.div<{ $showImage: boolean }>`
  position: absolute;
  inset: 0;
  overflow: hidden;
  background-image: ${({ $showImage }) =>
    $showImage ? `url(${HomeBackgroundImage})` : "none"};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 3% 55%;

  @media (max-width: 1200px) {
    background-position: center 50%;
  }

  @media (max-width: 768px) {
    background-position: center 40%;
    background-size: cover;
  }

  @media (max-width: 480px) {
    background-position: center 30%;
    opacity: 0.8;
  }
`;

export const Container = styled.div`
  height: 100%;
  position: relative;
`;

export const HeroSectionStyled = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  margin: 0 auto;
  position: relative;

  @media (max-width: 1830px) {
    flex-direction: column;
    height: 1250px;
  }

  @media (max-width: 1200px) {
    height: 1000px;
  }

  @media (max-width: 768px) {
    height: 800px;
  }

  @media (max-width: 480px) {
    height: 700px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 50%;
  height: 100%;
  padding: 250px 0px 0px 400px;
  box-sizing: border-box;
  gap: 16px;

  @media (max-width: 1830px) {
    width: 100%;
    height: auto;
    padding: 250px 50px;
    box-sizing: border-box;
    text-align: center;
    align-items: center;
  }

  @media (max-width: 1200px) {
    padding: 200px 100px;
    gap: 14px;
  }

  @media (max-width: 768px) {
    padding: 150px 40px;
    gap: 12px;
  }

  @media (max-width: 480px) {
    padding: 120px 20px;
    gap: 10px;
  }
`;

export const Title = styled.div`
  font-size: 50px;
  font-weight: 700;
  word-wrap: break-word;
  color: ${designTokens.colors.font.primary};

  span {
    font-size: 46px;
    font-weight: 600;
    color: ${designTokens.colors.font.primary};
  }

  @media (max-width: 1200px) {
    font-size: 44px;
    
    span {
      font-size: 40px;
    }
  }

  @media (max-width: 768px) {
    font-size: 36px;
    
    span {
      font-size: 32px;
    }
  }

  @media (max-width: 480px) {
    font-size: 28px;
    
    span {
      font-size: 26px;
    }
  }
`;

export const Description = styled.div`
  ${getTypography("korean", "title1")}
  margin-bottom: 24px;
  word-wrap: break-word;

  @media (max-width: 1200px) {
    font-size: 18px;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 18px;
    line-height: 1.5;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 16px;
    line-height: 1.4;
  }
`;

export const HeroImage = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 50%;
  height: 100%;
  position: relative;

  img {
    position: absolute;
    opacity: 1;
    z-index: 2;
    right: 0px;
    bottom: 0;
    transition: transform 1s ease, opacity 1s ease;
    max-width: 1150px;

    &.hidden {
      opacity: 0;
      transform: translateY(50px);
    }

    &.visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 1830px) {
    width: 100%;
    height: 100%;
    
    img {
      position: absolute;
      object-fit: contain;
      max-width: 1100px;
      bottom: 0;
      right: 0;
    }
  }

  @media (max-width: 1200px) {
    width: 100%;
    
    img {
      max-width: 900px;
      right: -50px;
      bottom: 0;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    
    img {
      max-width: 600px;
      right: -80px;
      bottom: 0;
      opacity: 0.7;
    }
  }

  @media (max-width: 480px) {
    width: 100%;
    
    img {
      max-width: 480px;
      right: -100px;
      bottom: 0;
      opacity: 0.5;
    }
  }

  @media (max-width: 360px) {
    img {
      max-width: 400px;
      right: -120px;
      opacity: 0.3;
    }
  }
`;
